import { useState } from "react";

const faqs = [
  {
    q: "开心漫画网上的漫画需要付费吗？",
    a: "开心漫画网目前所有精选沙雕漫画均可免费在线追更，无需付费即可阅读全部已更新内容。未来如有增值功能会提前公告，请放心开看。",
  },
  {
    q: "看漫画需要注册账号吗？",
    a: "游客也可以直接浏览和阅读大部分漫画。如果想收藏喜欢的作品、开启追更提醒，注册一个账号就能把最爱的一起装进书架，更新第一时间通知你。",
  },
  {
    q: "多久更新一次，追更会不会断更？",
    a: "我们每日精选更新，神转折一话接一话。热门连载作品一般每周多次更新，完结作品可一口气看完。你可以在追更专区查看每部作品的最新话状态。",
  },
  {
    q: "为什么有些漫画画风看起来特别魔性？",
    a: "魔性画风正是开心漫画网的一大特色。这类作品用夸张、洗脑的画面配合无厘头剧情，主打越看越上头的魔性体验，适合喜欢出其不意的读者。",
  },
  {
    q: "怎么向网站投稿或推荐好看的沙雕漫画？",
    a: "欢迎通过页面下方的反馈表单，把你喜欢或创作的无厘头脑洞作品推荐给我们。编辑审核后会优先推荐有趣的作品上架，帮助它们被更多读者看到。",
  },
  {
    q: "手机上看漫画体验怎么样？",
    a: "开心漫画网针对手机、平板和电脑做了完整适配，竖屏阅读体验顺畅，随时随地都能追更，通勤摸鱼两不误。",
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="relative w-full bg-background-100 py-12 md:py-16">
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-6 md:mb-10">
          <span className="inline-flex items-center gap-1.5 text-accent-600 text-sm font-bold mb-1">
            <i className="ri-question-line" aria-hidden="true"></i>
            常见问题
          </span>
          <h2 className="font-heading text-foreground-950 text-2xl md:text-4xl">你可能想知道</h2>
          <p className="text-foreground-600 text-sm mt-2">
            关于免费、追更、投稿与观看体验，这里都有答案。
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((f, i) => {
            const open = openIndex === i;
            return (
              <div
                key={f.q}
                className={`rounded-2xl border-2 bg-background-50 transition-colors ${
                  open ? "border-primary-400 shadow-comic-sm" : "border-background-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? -1 : i)}
                  className="w-full flex items-center justify-between gap-3 p-4 md:p-5 text-left cursor-pointer"
                  aria-expanded={open}
                >
                  <span className="font-heading text-foreground-950 text-sm md:text-base">
                    {f.q}
                  </span>
                  <span
                    className={`shrink-0 w-7 h-7 flex items-center justify-center rounded-full text-background-50 transition-transform ${
                      open ? "bg-primary-500 rotate-45" : "bg-secondary-400"
                    }`}
                  >
                    <i className="ri-add-line" aria-hidden="true"></i>
                  </span>
                </button>
                {open && (
                  <p className="px-4 md:px-5 pb-4 md:pb-5 text-foreground-600 text-sm leading-relaxed">
                    {f.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}